import React, { useState } from "react";
import ProgressBar from "../../../../components/ProgressBar";
import ImageUpload from "../comp/IDCapture";
import Header from "../../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { getApi, postApi } from "../../../AppApis";
import { toast } from "react-toastify";

export default function UploadCompanyDocument() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [formData, setFormData] = useState(null);

    function base64ToBlob(base64Data, contentType = "image/jpeg") {
        const byteCharacters = atob(base64Data.split(",")[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: contentType });
    }
    const handleNext = async () => {
        if (!formData) {
            alert("Please upload your document");
            return;
        }
        const formDataApi = new FormData();
        const ownerIdFrontBlob = base64ToBlob(state?.formData?.frontSide, "image/jpeg");
        const ownerIdBackBlob = base64ToBlob(state?.formData?.backSide, "image/jpeg");
        const corporateFormationDocumentBlob = base64ToBlob(formData.frontSide, "image/jpeg");
        formDataApi.append("owner_id_front", ownerIdFrontBlob, "front.jpg");
        formDataApi.append("owner_id_back", ownerIdBackBlob, "back.jpg");
        formDataApi.append("company_name", state?.formData?.companyName);
        formDataApi.append("business_registeration_number", state?.formData?.businessRegistrationNumber);
        formDataApi.append("country", state?.formData?.country);
        formDataApi.append("state", state?.formData?.state);
        formDataApi.append("corporate_formation_document", corporateFormationDocumentBlob, "front.jpg");
        formDataApi.append("user_photo", corporateFormationDocumentBlob, "front.jpg");
        try {
            const response = await postApi("/verifications/company-verification", formDataApi, true);
            navigate("/company-verification/success");
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong", { toastId: "error" });
        }
        return;
    };
    return (
        <div className="tw-pt-[100px] tw-px-4 max-sm:tw-px-2">
            <Header title={"Upload Company Document"} />
            <ProgressBar currentStep={3} totalSteps={3} />
            <div className="tw-w-[80%] max-sm:tw-w-[95%] tw-mx-auto tw-p-6 max-sm:tw-p-4">
                <div className="tw-mb-6 max-sm:tw-mb-4">
                    <h1 className="tw-text-[20px] max-sm:tw-text-[18px] tw-font-semibold tw-text-black tw-mb-2 tw-border-dashed tw-text-center">
                        Upload Your Document
                    </h1>

                    <div className="tw-text-black tw-text-sm max-sm:tw-text-xs tw-mb-4 tw-leading-tight tw-text-center">
                        <p className="tw-mb-1 tw-font-medium">Corporate Formation Documents</p>
                    </div>
                </div>

                <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 max-sm:tw-gap-3 tw-justify-center">
                    <div className="tw-max-w-md tw-w-full">
                        <ImageUpload formData={formData} setFormData={setFormData} label={"Document"} name={"frontSide"} />
                    </div>
                </div>

                <div className="tw-w-full tw-flex tw-justify-center tw-mt-6">
                    <button
                        onClick={handleNext}
                        className="tw-bg-primary tw-px-20 max-sm:tw-px-8 tw-text-white tw-py-2 max-sm:tw-py-3 tw-rounded-md hover:tw-bg-primary-hover tw-transition-colors tw-w-full max-sm:tw-max-w-xs tw-font-semibold"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}
